import { useState } from "react";
import { categoryTabs } from "@/mocks/gossip";

const FORM_URL = "https://readdy.ai/api/form/daf81brep053ijub1kog";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [honey, setHoney] = useState("");
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [formError, setFormError] = useState("");

  async function handleSubscribe(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    if (honey.trim()) {
      setStatus("success");
      return;
    }
    setStatus("loading");
    setFormError("");
    const form = e.currentTarget;
    try {
      const payload = new FormData(form);
      const res = await fetch(FORM_URL, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams(payload as unknown as Record<string, string>).toString(),
      });
      const responseText = await res.text();
      let parsed: Record<string, any> = {};
      try {
        parsed = responseText ? JSON.parse(responseText) : {};
      } catch {
        parsed = {};
      }
      const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;
      const isSpam = typeof serverMsg === "string" && serverMsg.includes("spam");
      if (!res.ok || !parsed?.code || parsed?.code !== "OK" || isSpam) {
        setStatus("error");
        setFormError(typeof serverMsg === "string" ? serverMsg : "提交失败，请稍后重试");
        return;
      }
      setStatus("success");
      setEmail("");
    } catch {
      setStatus("error");
      setFormError("网络异常，请稍后重试");
    }
  }

  return (
    <footer className="border-t border-background-200 bg-background-100">
      {/* newsletter band */}
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16 lg:px-10">
        <div className="grid grid-cols-1 items-center gap-8 lg:grid-cols-2">
          <div>
            <div className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-800">
              <i className="ri-notification-3-line"></i>
              追瓜提醒
            </div>
            <h2 className="font-heading mt-4 text-2xl font-bold text-foreground-950 md:text-3xl">
              你追的瓜，有更新第一时间提醒你
            </h2>
            <p className="mt-3 max-w-lg text-sm leading-relaxed text-foreground-600">
              留下邮箱，订阅吃瓜大全的资料库动态。当某个事件新增关键节点或资料库入库新瓜时，我们会不定期发送整理摘要，绝不刷屏。
            </p>
          </div>

          <div className="rounded-2xl border border-background-200 bg-background-50 p-5 md:p-6">
            <form onSubmit={handleSubscribe} data-readdy-form className="space-y-4">
              <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
                <label htmlFor="sub-email" className="sr-only">
                  邮箱地址
                </label>
                <input
                  id="sub-email"
                  type="email"
                  name="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="请输入常用邮箱"
                  className="flex-1 rounded-full border border-background-200 bg-background-50 px-5 py-3 text-sm text-foreground-900 outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-400 focus:ring-2 focus:ring-primary-200"
                />
                <button
                  type="submit"
                  disabled={status === "loading"}
                  className="inline-flex items-center justify-center gap-2 rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 whitespace-nowrap transition-colors hover:bg-primary-600 disabled:opacity-60"
                >
                  {status === "loading" ? (
                    <i className="ri-loader-4-line animate-spin text-base"></i>
                  ) : (
                    <i className="ri-send-plane-line text-base"></i>
                  )}
                  订阅追瓜
                </button>
              </div>
              <input
                type="text"
                name="company_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                value={honey}
                onChange={(e) => setHoney(e.target.value)}
                className="field-note"
              />
              {status === "success" ? (
                <p className="inline-flex items-center gap-2 rounded-lg bg-accent-50 px-3 py-2 text-sm font-medium text-accent-800">
                  <i className="ri-checkbox-circle-line"></i>
                  订阅成功，欢迎加入吃瓜大全追更小队
                </p>
              ) : null}
              {status === "error" ? (
                <p className="inline-flex items-center gap-2 rounded-lg bg-primary-50 px-3 py-2 text-sm font-medium text-primary-800">
                  <i className="ri-close-circle-line"></i>
                  {formError || "提交失败，请稍后重试"}
                </p>
              ) : null}
              <p className="text-xs text-foreground-400">
                提交即表示同意接收事件更新提醒，可随时取消订阅。我们不会共享你的邮箱。
              </p>
            </form>
          </div>
        </div>
      </div>

      {/* link columns */}
      <div className="border-t border-background-200">
        <div className="mx-auto grid max-w-7xl grid-cols-2 gap-8 px-4 py-10 md:grid-cols-4 md:px-6 lg:px-10">
          <div className="col-span-2 md:col-span-1">
            <a href="#top" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50">
                <i className="ri-eye-2-line text-lg"></i>
              </span>
              <span className="font-heading text-lg font-black text-foreground-950">
                吃瓜<span className="text-primary-600">大全</span>
              </span>
            </a>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-foreground-600">
              一份持续更新的娱乐事件资料库。把深度爆料按事件完整归档，从源头到尾声一页理清。
            </p>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold text-foreground-950">存档分类</h3>
            <ul className="mt-4 space-y-2.5">
              {categoryTabs
                .filter((c) => c.key !== "all")
                .map((c) => (
                  <li key={c.key}>
                    <a href="#archive" className="text-sm text-foreground-600 transition-colors hover:text-primary-700">
                      {c.label}
                    </a>
                  </li>
                ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold text-foreground-950">快速入口</h3>
            <ul className="mt-4 space-y-2.5">
              <li><a href="#hot" className="text-sm text-foreground-600 hover:text-primary-700">今日吃瓜速览</a></li>
              <li><a href="#archive" className="text-sm text-foreground-600 hover:text-primary-700">浏览完整存档</a></li>
              <li><a href="#timeline" className="text-sm text-foreground-600 hover:text-primary-700">深扒完整时间线</a></li>
              <li><a href="#about" className="text-sm text-foreground-600 hover:text-primary-700">关于我们与原则</a></li>
              <li><a href="#faq" className="text-sm text-foreground-600 hover:text-primary-700">常见问题</a></li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold text-foreground-950">联系编辑部</h3>
            <ul className="mt-4 space-y-3">
              <li>
                <a
                  href="mailto:hello@chigua-daquan.cn"
                  className="inline-flex items-center gap-2 text-sm text-foreground-600 hover:text-primary-700"
                >
                  <i className="ri-mail-line"></i>
                  hello@chigua-daquan.cn
                </a>
              </li>
              <li className="inline-flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-time-line"></i>
                内容随时可查，持续更新
              </li>
              <li>
                <button
                  onClick={() => {
                    const el = document.getElementById("faq");
                    el?.scrollIntoView({ behavior: "smooth" });
                  }}
                  className="inline-flex items-center gap-2 text-sm text-foreground-600 hover:text-primary-700"
                >
                  <i className="ri-question-answer-line"></i>
                  提交你关注的事件
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* bottom bar */}
      <div className="border-t border-background-200">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-4 py-5 text-center sm:flex-row sm:text-left md:px-6 lg:px-10">
          <p className="text-xs text-foreground-500">
            © {new Date().getFullYear()} 吃瓜大全 · 仅供信息参考，涉及"待核实"内容不构成既定事实
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <a href="#about" className="hover:text-primary-700">内容原则</a>
            <span className="h-3 w-px bg-background-300"></span>
            <a href="#faq" className="hover:text-primary-700">常见问题</a>
            <span className="h-3 w-px bg-background-300"></span>
            <a href="#top" className="hover:text-primary-700">回到顶部</a>
          </div>
        </div>
      </div>
    </footer>
  );
}